<!-- Text Block widget: a key figure tile (label, value and its unit, trend and description) -->
<div class="block-content" #htmlContent [class.alert]="alert" [class.accent]="showAccent" [style.background-color]="background"
  [style.color]="color" [style.--kpi-accent]="accent" [style.--kpi-title-size.px]="titleSize" [style.--kpi-value-size.px]="valueSize">
  <div *ngIf="!isLoading()" class="kpi" [ngClass]="['align-' + align, titleOnTop ? 'title-top' : 'title-bottom']">
    <span class="error" *ngIf="error">{{ error }}</span>

    <p class="kpi-label" *ngIf="showTitle">
      <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
      <span>{{ title }}</span>
    </p>

    <p class="kpi-value" data-testid="widget-text-value">
      <span>{{ blockValue }}</span>
      <span class="kpi-unit" *ngIf="unit">{{ unit }}</span>
    </p>

    <div class="kpi-foot" *ngIf="trend || landing || description">
      <p class="kpi-trend" *ngIf="trend"
        [attr.title]="previousValue ? ('editor.trend_previous_value' | translate: { value: previousValue }) : null">
        <span class="kpi-delta" [ngClass]="'tone-' + trend.tone">
          <mat-icon *ngIf="trendIcon">{{ trendIcon }}</mat-icon>
          {{ trendIcon ? '' : trend.symbol }}<ng-container *ngIf="trend.percent !== null">{{ trendPercent }} %</ng-container>
        </span>
        {{ previousValue ? ('editor.trend_vs_value' | translate: { value: previousValue }) : ('editor.trend_vs_previous' | translate) }}
        <ng-container *ngIf="previousPeriod"> · {{ previousPeriod }}</ng-container>
      </p>

      <!-- The landing: where the period should end, against the whole previous one -->
      <p class="kpi-landing" *ngIf="landing">
        <span>{{ 'editor.landing_end' | translate: { period: landingEnd } }} ≈ <strong>{{ landingValueText }}</strong></span>
        <ng-container *ngIf="landingTrend">
          <span class="kpi-delta" [ngClass]="'tone-' + landingTrend.tone">
            <mat-icon *ngIf="landingTrendIcon">{{ landingTrendIcon }}</mat-icon>
            {{ landingTrendIcon ? '' : landingTrend.symbol }}<ng-container *ngIf="landingTrend.percent !== null">{{ landingTrendPercent }} %</ng-container>
          </span>
          <span>{{ 'editor.trend_vs_value' | translate: { value: landingPrevious } }}</span>
        </ng-container>
        <app-forecast-note class="compact" [compact]="true" [meta]="landingMeta" [details]="landingDetails"></app-forecast-note>
      </p>

      <p class="kpi-description" *ngIf="description">{{ description }}</p>
    </div>
  </div>

  <app-widget-loading *ngIf="isLoading()" [graphType]="widget?.graphType"></app-widget-loading>

  <div id="chart-rendered" *ngIf="widgetRendered && !isLoading()"></div>
</div>
